// extracted by mini-css-extract-plugin
export var accent = "_64-4";
export var add = "_64-j";
export var addIcon = "_64-k";
export var deleteIcon = "_64-i";
export var disabled = "_64-9";
export var ellipsis = "_64-f";
export var error = "_64-3";
export var form = "_64-5";
export var hideFocus = "_64-2";
export var icon = "_64-7";
export var input = "_64-e";
export var listItem = "_64-h";
export var mediumHeight = "_64-b";
export var noBorder = "_64-8";
export var noRadius = "_64-1";
export var shortHeight = "_64-a";
export var tallHeight = "_64-c";
export var textInput = "_64-0";
export var vertical = "_64-g";
export var veryTallHeight = "_64-d";
export var widget = "_64-6";